module.exports = __webpack_public_path__ + "static/severe_winters_LR-f0ea6a36c1fe7110cfc46eb6d26a2976.mp4";